import {EnumType, JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {AtividadeDimensao} from "./atividade.dimensao";
import {CompetenciaDimensao} from "./competencia.dimensao";
import {Municipio} from "./municipio";
import {MunicipioDimensao} from "./municipio.dimensao";
import {Pessoa} from "./pessoa";
import {ExigibilidadeISSEnum} from "../enums/exigibilidade.iss.enum";
import {PapelServicoEnum} from "../enums/papel.servico.enum";
import {TipoFatoGeradorEnum} from "../enums/tipo.fato.gerador.enum";
import {TipoRegimeISSEnum} from "../enums/tipo.regime.iss.enum";

@JacksonType("CreditoAReceberAtividade")
@JsonIdentityInfo()
export class CreditoAReceberAtividade extends SonnerBaseEntity {

  id: number;

  @JacksonType("AtividadeDimensao")
  atividade: AtividadeDimensao;

  @JacksonType("CompetenciaDimensao")
  competencia: CompetenciaDimensao;

  @JacksonType("Pessoa")
  contribuinteResponsavel: Pessoa;

  @EnumType(ExigibilidadeISSEnum)
  exigibilidade: ExigibilidadeISSEnum;

  @JacksonType("Municipio")
  municipio: Municipio;

  @JacksonType("MunicipioDimensao")
  municipioIncidencia: MunicipioDimensao;

  @EnumType(PapelServicoEnum)
  papel: PapelServicoEnum;

  quantidadeTomadoresDistintos: number;

  @EnumType(TipoRegimeISSEnum)
  regimeContribuinteGerador: TipoRegimeISSEnum;

  @EnumType(TipoFatoGeradorEnum)
  tipoFatoGerador: TipoFatoGeradorEnum;

  valorBrutoFaturamento: number;

  valorCreditos: number;

  valorDeducoes: number;

  valorDeducoesBaseCalculoEncerramento: number;

  valorDescontoImpostoNF: number;

  valorTributo: number;

  valorTributoForaMunicipio: number;
}
